import { ScimConfig } from './scim.config';

export function defaultScimConfig(): ScimConfig {
    return {
        enabled: false,
        enableRoleManagement: false,
        enableDeactivate: false,
        sendInviteEmail: true,
        defaultRole: null,
        companies: []
    };
}

export function resolveScimConfig(value?: Partial<ScimConfig>): ScimConfig {
    return {
        ...defaultScimConfig(),
        ...(value ?? {})
    };
}
